<script lang="ts">
	import { NewsLayout } from '#lib/websites/news/components/NewsLayout/index.js';

	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();
</script>

<NewsLayout>
	{@render children?.()}
</NewsLayout>
